module.exports = __webpack_public_path__ + "static/media/hellosign.a7b33f2e.gif";